module.exports = __webpack_public_path__ + "img/s-mock-interview.1c4fb2f5.svg";